import LoginRequiredModal from 'components/Modal/LoginRequiredModal'
import { useNavigate, useParams } from 'react-router-dom'
import usePinProfiles from './hooks/usePinProfiles'
import useProfileEdit from './hooks/useProfileEdit'
import { useModal } from 'contexts/ModalContext'
import { useAuth } from 'contexts/AuthContext'
import Logo from 'assets/img/logo-notext.svg'
import React, { useState } from 'react'
import Loader from 'components/Loader'
import './index.scss'

const Explainer: React.FC = () => {
  const params = useParams()
  const { isAuth } = useAuth()
  const [isModal, setModal] = useState(false)
  const { isEdit, editProfile } = useProfileEdit()
  const { isLoading, data } = usePinProfiles(() => {
    navigate(getRedirectPathname())
  })

  const showModal = useModal()
  const navigate = useNavigate()
  const getRedirectPathname = () => {
    return params['*'] ? `/addprofile/${params['*']}/add` : '/addprofile'
  }

  const handleNext = () => {
    if (isAuth) navigate(getRedirectPathname())
    else setModal(true)
  }

  if (isEdit) return (
    <Loader type='full' />
  )

  return (
    <>
      {isModal && <LoginRequiredModal
        customRedirect={{ pathname: window.location.pathname }}
        onClose={() => {
          showModal()
        }}
      />}

      <div className='explainer unpublish'>
        <div className='unpublished__content'>
          <div
            className='unpublished__logo'
            onClick={() => {
              navigate('https://mojekondolencje.pl')
            }}>
            <img src={Logo} alt='logo' />
            <h2>Tabliczka jest pusta</h2>
          </div>

          {isAuth
            ? isLoading
              ? <Loader type='full' />
              : <div>
                <div className='warning'>
                  Wybierz z pośród utworzonych profili<br />
                  lub utwórz nowy profil
                </div>
                {data?.map(({ id, name }, index) => <div
                  key={id}
                  className='step'
                  onClick={() => {
                    const qrId = params['*']
                    if (qrId) editProfile(qrId, id)
                  }}>
                  <div className='step__number'>{index + 1}</div>
                  <div className='step__content'>{name}</div>
                </div>)}
                <div
                  className='step'
                  onClick={handleNext}>
                  Utwórz nowy profil
                </div>
              </div>
            : <div>
              <div className='warning'>
                Co dalej?
              </div>
              <div
                className='step black'
                onClick={() => {
                  setModal(true)
                }}>
                <div className='step__number'>1</div>
                <div className='step__content'>
                  Zaloguj lub zarejestruj się do aplikacji
                </div>
              </div>
              <div className='step'>
                <div className='step__number'>2</div>
                <div className='step__content'>
                  Uzupełnij dane Twojego bliskiego lub połącz z istniejącym profilem
                </div>
              </div>
            </div>}
        </div>

        {!isAuth && <div className="unpublished__footer">
          <div className="btn btn--primary" onClick={handleNext}>Dalej</div>
        </div>}
      </div>
    </>
  )
}

export default Explainer